import { OrderStatusEnum } from "@src/features/order/entities";
import { DatePreset, OrderFilters } from "./types";

export const DEFAULT_ORDER_FILTERS: OrderFilters = {
  orderTypes: [],
  hubIds: [],
  datePreset: DatePreset.ALL_TIME,
  customStart: null,
  customEnd: null,
};

export const ORDER_TYPE_OPTIONS: { value: OrderStatusEnum; labelKey: string }[] = [
  { value: OrderStatusEnum.COMPLETED, labelKey: "history.filter.orderType.completed" },
  { value: OrderStatusEnum.CANCELLED, labelKey: "history.filter.orderType.cancelled" },
  { value: OrderStatusEnum.ERROR, labelKey: "history.filter.orderType.error" },
];

export const DATE_PRESET_LABEL_KEYS: Record<DatePreset, string> = {
  [DatePreset.ALL_TIME]: "history.filter.date.allTime",
  [DatePreset.TODAY]: "history.filter.date.today",
  [DatePreset.YESTERDAY]: "history.filter.date.yesterday",
  [DatePreset.LAST_7_DAYS]: "history.filter.date.last7Days",
  [DatePreset.LAST_30_DAYS]: "history.filter.date.last30Days",
  [DatePreset.THIS_MONTH]: "history.filter.date.thisMonth",
  [DatePreset.CUSTOM]: "history.filter.date.customRange",
};

export const DATE_PRESET_OPTIONS: DatePreset[] = Object.keys(
  DATE_PRESET_LABEL_KEYS,
) as DatePreset[];

export const DROPDOWN_MENU_PROPS = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
} as const;
